import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getSettings } from '@/api/settings';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import { AdminModule } from '@/store/modules/admin';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.role = AdminModule.roles;
    this.listQuery = {
      page: 1,
      limit: 10,
      sort: 'id,ASC'
    };
    this.value = [];
    this.options = [{
      value: 'rate',
      label: 'Rate'
    }, {
      value: 'createdDate',
      label: 'Created Date'
    }];
    this.columns = {
      createdDate: false,
      rate: false
    };
    this.showCreatedDate = false;
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await getSettings(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleColumn() {
    for (var c in this.columns) {
      this.columns[c] = this.value.includes(c);
    }
  }
};
default_1 = __decorate([Component({
  name: 'SettingList',
  components: {
    Pagination
  }
})], default_1);
export default default_1;